// ============================================================================
// TRIAGE OUTCOME CLASSIFIER — single source of truth for urgent/routine/not-yet
//
// Triage Queue Health and the Ops Command Center triage card MUST classify a
// referral's outcome identically, or their urgent/routine counts diverge.
// This helper centralizes the field-resolution + normalization so the two
// screens can never disagree again.
//
// Resolution order (first non-empty wins):
//   1. item.referral.finalOutcome        (contract field; not currently persisted)
//   2. item.referral.outcome.status      (what buildReferralDoc actually writes, lowercase)
//   3. item.workflow.sourceOutcomeStatus (canonical mirror on workflow/state)
//   4. null
//
// Returns one of: 'URGENT' | 'ROUTINE' | 'NOT_YET' | null
// ============================================================================

export function classifyTriageOutcome(item) {
  const raw = item?.referral?.finalOutcome
    || item?.referral?.outcome?.status
    || item?.workflow?.sourceOutcomeStatus
    || null;

  if (!raw) return null;

  const up = String(raw).toUpperCase();
  if (up === 'URGENT') return 'URGENT';
  if (up === 'ROUTINE') return 'ROUTINE';
  if (up === 'NOT_YET') return 'NOT_YET';
  return null;
}
